/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Workflow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M13 11a2 2 0 11.001 3.999A2 2 0 0113 11zM11.5 1a3.5 3.5 0 110 7H5a2 2 0 100 4h3a1 1 0 010 2H5c-2.21 0-4-1.79-4-4s1.79-4 4-4h6.5a1.5 1.5 0 001.493-1.356L13 4.5A1.5 1.5 0 0011.5 3H6a1 1 0 010-2zM2 1a1 1 0 110 2 1 1 0 010-2z"
        />
    </AccessibleSVG>
);

export default Workflow16;
